(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documentsearch', {
      restrict: 'E',
      bindings: {
        document: '<',
        documentref: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showdocument($item, $model, $label)"
                   uib-typeahead="document as document.text for document in vm.getDocuments($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addDocument()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addDocument()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <documenteditor document="vm.document"></documenteditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Document', 'DocumentHelper',
        function ($log, Document, DocumentHelper) {
          let vm = this;
          vm.save = save;
          vm.showdocument = showdocument;

          vm.getDocuments = getDocuments;
          // vm.addDocument = DocumentHelper.addDocument;
          vm.addDocument = addDocument;
          vm.editDocument = DocumentHelper.editDocument;

          vm.$onInit = function () {
            vm.newdocument = {};

            if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
              vm.editinplace = true;
            }

            $log.debug('debug - editinplace', vm.editinplace);


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastdocument = angular.copy(vm.documentresult);
            vm.lastdocumentref = angular.copy(vm.documentref);
          };

          function addDocument() {
            $log.debug('debug - documentsearch addDocument called');
            DocumentHelper.addDocument(function (doc) {
              $log.debug('debug: handle newly create document');
              vm.document = {};
              vm.document.name = doc.name;
              vm.document.short = doc.short;
              vm.document._id = doc._id;
              vm.documentref = doc._id;
              vm.asyncSelected = doc.short;
              vm.parentsave({document: vm.document, documentref: vm.documentref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead document search backend query
          function getDocuments(val) {
            // return Documentahead.$search({query: val}).$asPromise().then(function (response) {
            return Document.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (doc) {
                doc.text = doc.short;
                delete vm.error;
                return doc;
              });
            });
          }

          // typeahead document search action
          function showdocument($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.document = $model;
            vm.documentref = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true) {
              vm.document = $model;
              vm.documentref = $model._id;
              $log.debug('debug - documentsearch editinplace');
            }
            else {
              vm.document = {};
              vm.document.name = $model.name;
              vm.document.short = $model.short;
              vm.document._id = $model._id;
              vm.documentref = $model._id;
              vm.parentsave({document: vm.document, documentref: vm.documentref});
              $log.debug('debug - documentsearch do not  editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.document, vm.lastdocument) || !angular.equals(vm.documentref, vm.lastdocumentref)) {
              vm.lastdocument = angular.copy(vm.document);
              vm.lastdocumentref = angular.copy(vm.documentref);
              vm.parentsave({document: vm.document, documentref: vm.documentref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
